<div class="acordeon-container border h-full mb-2">
  <mat-accordion>
    <mat-expansion-panel [expanded]="data.length > 0">
      <mat-expansion-panel-header
        class="py-2 !px-4 item-process-quote"
        [style.background-color]="color"
      >
        <div class="text-white flex justify-between items-center">
          <div class="text-lg">{{ title }}</div>
        </div>
      </mat-expansion-panel-header>

      <table mat-table [dataSource]="dataSource" matSort class="w-full bg-white mat-elevation-z1">
        <ng-container matColumnDef="rowNumber">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <ng-container *ngIf="showCellContent(row, 'rowNumber')">
              {{ i + 1 }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="description">Description</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="showCellContent(row, 'description')">
              {{ row.description }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="uniqueIdentifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="uniqueId">Unique ID</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="showCellContent(row, 'uniqueIdentifier')">
              {{ row.uniqueIdentifier }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="innerDiameter">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="id">ID</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <ng-container *ngIf="showCellContent(row, 'innerDiameter')">
              @if (readOnly) {
                {{ row.innerDiameter || 0 }}
              } @else {
                <form [formGroup]="form">
                  <mat-form-field class="w-24">
                    <input
                      matInput
                      type="text"
                      inputmode="decimal"
                      pattern="^[0-9]*[.]?[0-9]*$"
                      [formControlName]="'innerDiameter_' + i"
                      class="text-right"
                      (keypress)="onNumericKeyPress($event)"
                    />
                  </mat-form-field>
                </form>
              }
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="outerDiameter">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="outerDiameter">OD</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <ng-container *ngIf="showCellContent(row, 'outerDiameter')">
              @if (readOnly) {
                {{ row.outerDiameter || 0 }}
              } @else {
                <form [formGroup]="form">
                  <mat-form-field class="w-24">
                    <input
                      matInput
                      type="text"
                      inputmode="decimal"
                      pattern="^[0-9]*[.]?[0-9]*$"
                      [formControlName]="'outerDiameter_' + i"
                      class="text-right"
                      (keypress)="onNumericKeyPress($event)"
                    />
                  </mat-form-field>
                </form>
              }
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="lbPer1000ft">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="lbPer1000ft">Lbs Per 1000ft</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="showCellContent(row, 'lbPer1000ft')">
              {{ row.lbPer1000ft }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="pricePerLb">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="pricePerLb">Price/LB</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="showCellContent(row, 'pricePerLb')">
              {{ row.pricePerLb | currency }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="pricePerUnit">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="pricePerUnit">Price/Unit</th>
          <td mat-cell *matCellDef="let row; let i = index">
            @if (readOnly || row.isParent) {
              {{ row.pricePerUnit || 0 | currency }}
            } @else {
              <form [formGroup]="form">
                <mat-form-field class="w-24">
                  <input
                    matInput
                    type="text"
                    inputmode="decimal"
                    pattern="^[0-9]*[.]?[0-9]*$"
                    [formControlName]="'pricePerUnit_' + i"
                    class="text-right"
                    (keypress)="onNumericKeyPress($event)"
                  />
                </mat-form-field>
              </form>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="units">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="units">Units</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <ng-container *ngIf="showCellContent(row, 'units')">
              @if (readOnly) {
                {{ row.units || 0 }}
              } @else {
                <form [formGroup]="form">
                  <mat-form-field class="w-24">
                    <input
                      matInput
                      type="text"
                      inputmode="decimal"
                      pattern="^[0-9]*[.]?[0-9]*$"
                      [formControlName]="'units_' + i"
                      class="text-right"
                      (keypress)="onNumericKeyPress($event)"
                    />
                  </mat-form-field>
                </form>
              }
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="ftNeeded">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="ftNeeded">FT Needed</th>
          <td mat-cell *matCellDef="let row">
            {{ row.ftNeeded || 0 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="totalLbs">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="totalLbs">Total LBs</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="showCellContent(row, 'totalLbs')">
              {{ row.totalLbs || 0 | number: '1.2-2' }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="quantityBreakMargin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="quantityBreakMargin">
            Qty Break Margin
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            @if (readOnly) {
              {{ row.quantityBreakMargin || 0 }}
            } @else {
              <form [formGroup]="form">
                <mat-form-field class="w-24">
                  <input
                    matInput
                    type="text"
                    inputmode="decimal"
                    pattern="^[0-9]*[.]?[0-9]*$"
                    [formControlName]="'quantityBreakMargin_' + i"
                    class="text-right"
                    (keypress)="onNumericKeyPress($event)"
                  />
                </mat-form-field>
              </form>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="setup">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="setup">Setup</th>
          <td mat-cell *matCellDef="let row; let i = index">
            @if (readOnly) {
              {{ row.setup || 0 }}
            } @else {
              <form [formGroup]="form">
                <mat-form-field class="w-24">
                  <input
                    matInput
                    type="text"
                    inputmode="decimal"
                    pattern="^[0-9]*[.]?[0-9]*$"
                    [formControlName]="'setup_' + i"
                    class="text-right"
                    (keypress)="onNumericKeyPress($event)"
                  />
                </mat-form-field>
              </form>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="sellPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="sellPrice">SELL PRICE</th>
          <td mat-cell *matCellDef="let row">
            {{ row.sellPrice || 0 | currency }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="showCellContent(row, 'actions')">
              <button
                mat-icon-button
                color="primary"
                type="button"
                (click)="onEdit(row)"
                matTooltip="Edit item"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                type="button"
                (click)="onDelete(row)"
                matTooltip="Delete item"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-expansion-panel>
  </mat-accordion>
</div>
